/**
 * Obstruction Type Enum
 *
 * High-level category of a road-network obstruction. Mirrors backend
 * `GeoMarkup.Domain.Enums.ObstructionType` — stored as PascalCase strings.
 */
export enum ObstructionType {
  /** Routine repair / maintenance work. */
  Maintenance = 'Maintenance',
  /** Construction or reconstruction work. */
  Construction = 'Construction',
  /** Traffic accident or collision. */
  Accident = 'Accident',
  /** Planned road closure. */
  Closure = 'Closure',
  /** Event-driven obstruction (e.g. convoy passage). */
  Event = 'Event',
  /** Emergency situation requiring immediate attention. */
  Emergency = 'Emergency',
}
